//#region src/utils/constants.ts
const DEFAULT_SECRET = "better-auth-secret-12345678901234567890";
//#endregion
export { DEFAULT_SECRET };
